module.exports = __webpack_public_path__ + "img/eyes_male_asian_average.9ab5c2ae.png";